const utils = require('src/utils')
import AppHeader from 'components/AppHeader'
export default {
  name: 'propose-approved-list',
  created () {
    this.getStorageData()
    this.search(false)
    this.proposeCount()
    this.getShop()
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      searchCallbackFlag: false,
      shopGetCallbackFlag: false,
      shopIds: [],
      rankIds: [],
      userName: '',
      keyword: '',
      range: {
        startDate: null,
        endDate: null
      },
      ranks: [
        {
          name: '採用検討',
          value: 'considerating'
        },
        {
          name: 'テスト採用',
          value: 'testing'
        },
        {
          name: '正式採用',
          value: 'adopted'
        }
      ],
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'user_name': {'state': false, 'order': false},
        'shop_name': {'state': false, 'order': false},
        'contribution_date': {'state': false, 'order': false}
      }
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    proposes () {
      return this.$store.getters.proposeApprovedList
    },
    proposeTotalCount () {
      return this.$store.getters.proposeApprovedTotalCount
    },
    nextPage () {
      return this.$store.getters.proposeApprovedListNextPage
    },
    currentPage () {
      return this.$store.getters.proposeApprovedListCurrentPage
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    shops () {
      return this.$store.getters.shopsAll
    },
    validation () {
      let date
      if (this.range.startDate !== null && this.range.endDate !== null) {
        date = this.startDate <= this.endDate
      } else {
        date = true
      }
      return {
        date: date,
        integrity: date
      }
    },
    startDate: function () {
      let result
      if ([null, undefined, ''].includes(this.range.startDate)) {
        result = '1970-01-01 00:00:00'
      } else {
        const date = new Date(this.range.startDate)
        result = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + ' 00:00:00'
      }
      return result
    },
    endDate: function () {
      let result
      if ([null, undefined, ''].includes(this.range.endDate)) {
        result = '9999-12-31 23:59:59'
      } else {
        const date = new Date(this.range.endDate)
        result = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + ' 23:59:59'
      }
      return result
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function (readMore) {
      let data = {
        'shop_ids': this.shopIds,
        'user_name': this.userName,
        'propose_status': ['approved', 'adopted'],
        'order': this.orderByString(),
        'start_date': this.startDate,
        'end_date': this.endDate,
        'adopt_rank': this.rankIds,
        'keyword': this.keyword
      }

      if (readMore === true) {
        // さらに20件呼ぶ
        data['page[number]'] = this.nextPage
      } else if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込する
        data['re_search'] = this.currentPage
      }

      const self = this
      const callback = function () {
        self.searchCallbackFlag = true
        self.setStorageData()
      }

      this.$store.dispatch('PROPOSE_APPROVED_LIST_SEARCH', {url: '/master/proposes', data: data, callback: callback})
    },
    proposeCount: function () {
      const data = {'status': 'approved'}
      this.$store.dispatch('PROPOSE_COUNT', {data: data})
    },
    goProposeDetail: function (proposeId) {
      this.$router.push({ path: '/propose_before_adopt/' + proposeId })
    },
    proposeDelete: function (proposeId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('PROPOSE_DELETE', {id: proposeId, callback: this.onSaved})
      }
    },
    onSaved: function () {
      this.$router.push('/propose_before_adopt_list')
    },
    getShop: function () {
      const self = this
      const callback = function () {
        self.shopGetCallbackFlag = true
        // 退職者一覧店舗を表示しない
        let workIndex = 0
        for (let i = 0; i < self.shops.length; i++) {
          if (self.shops[i].id == 800) {
            workIndex = i
            break
          }
        }
        if (workIndex !== 0) {
          self.shops.splice(workIndex, 1)
        }
      }

      this.$store.dispatch('SHOP_ALL_GET', {callback: callback})
    },
    half: function () {
      this.userName = utils.emHalf(this.userName)
    },
    sortBy: function (key) {
      this.sortKey = key
      // sortStateOrderをtrueにする
      this.sortStateOrder = !this.sortState[key].order
      // sortState内を全部falseにする
      for (let k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      // ソート対象だけtrueに
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order
      // 検索
      this.search('sort')
    },
    /** ソート文字列取得 */
    orderByString: function () {
      let result = []
      for (let key in this.sortState) {
        if (this.sortState[key].state) {
          let ascDesc = 'asc'
          if (!this.sortState[key].order) {
            ascDesc = 'desc'
          }
          result.push(key + ' ' + ascDesc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('contribution_date desc')
      }
      return result.join(' , ')
    },
    getArrow: function (key) {
      const state = this.sortState[key].state ? ' color-light-blue' : ''
      const arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    getStorageData: function () {
      const shopIds = window.sessionStorage.getItem('shopIds')
      const userName = window.sessionStorage.getItem('userName')
      const startDate = window.sessionStorage.getItem('startDate')
      const endDate = window.sessionStorage.getItem('endDate')
      const rankIds = window.sessionStorage.getItem('rankIds')
      const keyword = window.sessionStorage.getItem('keyword')

      this.shopIds = [null, undefined, ''].includes(shopIds) ? [] : shopIds.split(',')
      this.userName = [null, undefined, ''].includes(userName) ? '' : userName
      this.range.startDate = startDate === '1970-01-01 00:00:00' ? null : startDate
      this.range.endDate = endDate === '9999-12-31 23:59:59' ? null : endDate
      this.rankIds = [null, undefined, ''].includes(rankIds) ? [] : rankIds.split(',')
      this.keyword = [null, undefined, ''].includes(keyword) ? '' : keyword
    },
    setStorageData: function () {
      window.sessionStorage.setItem('shopIds', this.shopIds.toString())
      window.sessionStorage.setItem('userName', this.userName)
      window.sessionStorage.setItem('rankIds', this.rankIds.toString())
      window.sessionStorage.setItem('keyword', this.keyword)
      window.sessionStorage.setItem('startDate', this.startDate)
      window.sessionStorage.setItem('endDate', this.endDate)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-approved-list.js